<footer class="{{footerClass}}" *ngIf = "isLoaded">
  <p>Memic Group © {{currentYear}} | All Rights Reserved.<br />
  <a class="optanon-toggle-display cookie-settings-button" id="cookie-settings" title="Cookie Settings" style="cursor: pointer">Cookie Settings</a></p>
</footer>